<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-container-single element-non-bodymatter element-type-toc" id="table-of-contents">
<div class="toc-heading"><h1 class="toc-title">Contents</h1></div>
<div class="toc-contents">
<div class="toc-bodymatter-group">
<div class="toc-volume-group has-no-volume-author has-no-children">
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-volume has-no-leading-number has-no-children has-no-page-number">
<p class="element-title"><a href="#/vol001"><span class="element-title-text">Legacy of Lies</span></a></p>
</div>
</div>
<div class="toc-volume-group has-no-volume-author has-no-children">
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-volume has-no-leading-number has-no-children has-no-page-number">
<p class="element-title"><a href="#/vol002"><span class="element-title-text">Legacy Lost</span></a></p>
</div>
</div>
<div class="toc-volume-group has-no-volume-author has-no-children">
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-volume has-no-leading-number has-no-children has-no-page-number">
<p class="element-title"><a href="#/vol003"><span class="element-title-text">Legacy of Danger</span></a></p>
</div>
</div>
</div>
<div class="toc-backmatter-group">
<div class="toc-item toc-item-element-non-bodymatter toc-item-element-type-none has-no-leading-number has-no-children has-no-page-number">
<p class="element-title"><a href="#/beforeyougo"><span class="element-title-text">Before You Go…</span></a></p>
</div>
<div class="toc-item toc-item-element-non-bodymatter toc-item-element-type-acknowledgments has-no-leading-number has-no-children has-no-page-number">
<p class="element-title"><span href="#/acknowledgments" title="Link target outside of Sample"><span class="element-title-text">Acknowledgments</span></span></p>
</div>
<div class="toc-item toc-item-element-non-bodymatter toc-item-element-type-none has-no-leading-number has-no-children has-no-page-number">
<p class="element-title"><a href="#/legacyfound"><span class="element-title-text">Legacy Found</span></a></p>
</div>
<div class="toc-item toc-item-element-non-bodymatter toc-item-element-type-also-by has-no-leading-number has-no-children has-no-page-number">
<p class="element-title"><a href="#/alsobyjilliandavid"><span class="element-title-text">Also by Jillian David</span></a></p>
</div>
<div class="toc-item toc-item-element-non-bodymatter toc-item-element-type-about-author has-no-leading-number has-no-children has-no-page-number">
<p class="element-title"><a href="#/abouttheauthor"><span class="element-title-text">About the Author</span></a></p>
</div>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?33162ca6